import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SiteFooter } from "@/components/BrandFooter";

export const PageShell = ({ testid, icon: Icon, iconClass, title, intro, children }) => (
  <div className="h-screen overflow-y-auto bg-atlas-void text-atlas-foreground grid-backdrop" data-testid={testid}>
    <div className="max-w-5xl mx-auto px-6 py-10">
      <Link to="/" data-testid={`${testid}-back`} className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-atlas-secondary hover:text-white mb-8">
        <ArrowLeft className="w-3.5 h-3.5" /> Observatory
      </Link>
      <div className="flex items-center gap-3 mb-2">
        <Icon className={`w-7 h-7 ${iconClass}`} />
        <h1 className="text-4xl sm:text-5xl font-display text-white">{title}</h1>
      </div>
      <p className="text-sm text-atlas-secondary max-w-2xl mb-10">{intro}</p>
      {children}
      <SiteFooter />
    </div>
  </div>
);

export const EmptyBox = ({ testid, title, text }) => (
  <div className="border border-dashed border-white/15 p-10 text-center" data-testid={testid}>
    <p className="text-sm text-white mb-1">{title}</p>
    <p className="text-[12px] text-atlas-secondary">{text}</p>
  </div>
);
